module.exports = __webpack_public_path__ + "img/slide1.8a8e6b2d.png";